/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
'use es6';

import Widget from 'DesignData/models/widgets/Widget';
import ContentAvailability from 'DesignData/models/widgets/utils/ContentAvailability';
import { CONTENT } from 'DesignData/enums/CustomWidgetEditableContexts';
import { createOptimizedPick } from 'DesignData/lib/object';
import { getInitialWidgetParams } from 'DesignData/lib/layoutTreeDataHelper';
const CUSTOM_WIDGET_PROPS = ['id', 'label', 'name', 'displayName', 'moduleId', 'fields', 'schemaVersion', 'icon', 'global', 'hostTemplateTypes', 'contentTypes', 'editableContexts', 'default', 'tags', 'contentTags', 'isAvailableForNewContent', 'isEnabledForEmailV3Rendering', 'masterLanguage', 'messages', 'path', 'isThemeAsset'];
const pickProps = createOptimizedPick(CUSTOM_WIDGET_PROPS);
const privy = new WeakMap();
/**
 */

export default class CustomWidget extends Widget {
  /**
   * @constructor
   */
  constructor(props) {
    return super(Object.assign({}, pickProps(props), {
      type: 'custom_widget'
    }));
  }

  get contentAvailability() {
    let contentAvailability = privy.get(this);

    if (!contentAvailability) {
      const options = {
        isCustomWidget: true
      };
      contentAvailability = new ContentAvailability(this, options);
      privy.set(this, contentAvailability);
    }

    return contentAvailability;
  }

  get isDisabled() {
    return this.schemaVersion > 1 && this.isAvailableForNewContent === false;
  }
  /**
   * Returns an object widget with minimum requirements for use in a layout's tree.
   *
   * @override
   * @return {Object}
   */


  generateNewLayoutWidgetObject(options = {}) {
    const {
      isEmail
    } = options;
    const {
      id,
      displayName,
      name,
      schemaVersion,
      moduleId,
      path,
      editableContexts = []
    } = this;
    const superWidgetObject = super.generateNewLayoutWidgetObject();
    const overrideable = !!(!editableContexts.length || ~editableContexts.indexOf(CONTENT));
    return Object.assign({}, superWidgetObject, {
      label: displayName || name,
      params: Object.assign({}, superWidgetObject.params, {
        // TODO: remove after `DesignManager:LayoutWidgetPreferPathKey` ungated to all
        custom_widget_id: id,
        widget_name: name,
        overrideable,
        schema_version: schemaVersion,
        // TODO: remove after `DesignManager:LayoutWidgetPreferPathKey` ungated to all
        module_id: moduleId,
        path
      }, getInitialWidgetParams(this, {
        isEmail
      }))
    });
  }

}